// react
import { List, Map, fromJS } from "immutable";

const initialState = Map({
	memoryJobMap: Map(), // stores jobs in memory for referencing after they have been completed
	receivedFirstResponse: false,
	jobs: List(),
});

export default function jobs(state = initialState, action) {
	switch (action.type) {
		/**
		 * This will update the `jobs` list, which is just a list of active
		 * jobs, and update the `memoryJobMap` which just holds a list of all
		 * jobs in memory. This will allow the app to reference previous jobs.
		 */
		case "JOBS:UPDATE": {
			return state.withMutations((mutable) => {
				mutable.setIn(["jobs"], fromJS(action.jobs));

				action.jobs.forEach((job) => {
					mutable.setIn(["memoryJobMap", job._id], fromJS(job));
				});
			});
		}

		case "JOBS:FIRSTRESPONSE": {
			return state.setIn(["receivedFirstResponse"], true);
		}

		case "JOBS:WEBSOCKET:ERROR": {
			return state.setIn(["failedWebsocketStatus"], true);
		}

		default:
			// never forget your default return state!
			return state;
	}
}
